// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SearchVoucherInformation_tooltip__1oUXf"};